import script from "./HeaderDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDefault.vue?vue&type=script&setup=true&lang=js"

import "./HeaderDefault.vue?vue&type=style&index=0&id=fe9ff596&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe9ff596"]])

export default __exports__